import classnames from "classnames";
import Accordion from "react-bootstrap/Accordion";
import "./index.scss";

export const PDLAccordionItem = ({ children, className = "", ...props }) => (
  <Accordion.Item
    className={classnames("pdl_dna_accordion_item", className)}
    {...props}
  >
    {children}
  </Accordion.Item>
);

export const PDLAccordionItemBody = ({
  children,
  className = "",
  ...props
}) => (
  <Accordion.Body
    className={classnames("pdl_dna_accordion_item_body", className)}
    {...props}
  >
    {children}
  </Accordion.Body>
);

export const PDLAccordionItemHeader = ({
  children,
  className = "",
  ...props
}) => (
  <Accordion.Header
    className={classnames("pdl_dna_accordion_item_header px-4 py-2", className)}
    {...props}
  >
    {children}
  </Accordion.Header>
);

export const PDLAccordion = ({ children, className = "", ...props }) => (
  <Accordion className={classnames("pdl_dna_accordion", className)} {...props}>
    {children}
  </Accordion>
);
